import { Box, Text } from '@bonanza-social/moonlight';
import { Dispatch, memo, SetStateAction, useCallback, useState } from 'react';
import { Pressable } from 'react-native';
import {
  TAB_HEIGHT,
  TAB_MIN_WIDTH,
  TabSectionItems,
} from './TabsSection.constants';
import { InviteFriendsScreens } from '../InviteFriendsComponent.types';

function TabsSection({
  setScreen,
}: {
  setScreen: Dispatch<SetStateAction<InviteFriendsScreens>>;
}) {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const onPress = useCallback(
    (index: number, screen: InviteFriendsScreens) => {
      setSelectedIndex(index);
      setScreen(screen);
    },
    [setScreen],
  );

  return (
    <Box
      flexDirection="row"
      gap="space-200"
      flexWrap="wrap"
      width={{
        mobile: undefined,
        tablet: 650,
        desktop: 650,
      }}
      marginHorizontal={{
        mobile: undefined,
        tablet: 'auto',
        desktop: 'auto',
      }}
      marginTop={{ mobile: 'space-400', desktop: undefined, tablet: undefined }}
    >
      {TabSectionItems.map((item, index) => (
        <Box key={index} testID={`invite-friends-${item.locKey}`}>
          <Pressable onPress={() => onPress(index, item.screen)}>
            <Box
              {...(selectedIndex === index
                ? {
                    variant: 'gradient',
                    gradient: 'accentBackground',
                  }
                : {
                    variant: 'default',
                    backgroundColor: 'onLightTertiaryBackground',
                  })}
              borderRadius="radius-full"
              padding="space-050"
            >
              <Box
                backgroundColor="onLightTertiaryBackground"
                borderRadius="radius-full"
                height={TAB_HEIGHT}
                minWidth={TAB_MIN_WIDTH}
                justifyContent="center"
                alignItems="center"
              >
                <Text
                  variant="input-label"
                  locNS="inviteFriends"
                  locKey={item.locKey}
                  color="darkSurfacePrimary"
                />
              </Box>
            </Box>
          </Pressable>
        </Box>
      ))}
    </Box>
  );
}

export default memo(TabsSection);
